<form *ngIf="form && fields && texts" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">
          <span *ngIf="!editMode">{{texts.add_title}}</span>
          <span *ngIf="editMode">{{texts.edit_title}}</span>
        </h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/cluster-type" label="{{texts.back}}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{texts.save}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</span>
          <input type="text" pInputText maxlength="{{maxLength.code}}" class="fieldInput" formControlName="code" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.code"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText maxlength="{{maxLength.description}}" class="fieldInput" formControlName="description" />
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster-type/form-cluster-type-loyalty/form-cluster-type-loyalty.component.html